import { FullScreenContentContainer } from "../layout/FullScreenContainer";
import { AccentedText } from "../layout/style";
import { FigureContainer } from "./style";
import styled from "styled-components";
import { ReadNextSection } from "./style";
import { LoopSectionName } from "../layout/LoopSection";
import { breakpoint } from "../layout/style";

const Table = styled.table`

    font-size: 16pt;
    line-height: 30pt;
    text-align: left;
    width: 100%;

    & th {
        text-align: left;
        vertical-align: bottom;
        width: 33%;
    }

    & th, td {
        padding-right: 50px;
        
    }

    & td {
        vertical-align: top;
    }

    @media ${breakpoint.phone} {

        font-size: 12pt;
        line-height: 20pt;

        & th, td {
            padding-right: 5px;
        }
    }
`;

// Starting time for sample data: 1696344902687

const Data = ({setWhichSectionToView}) => {

    return <FullScreenContentContainer>
        <p>The sensors send a signal from transmitters to a receiver, which is connected to a computer. The computer then translates these incoming signals into a data series that can be read and used as a measurement of changes in pressure. Specifically, the absolute magnitude of pressure on each sensor is mapped to an 8-bit value between 0 and 127. When the value is 0, no pressure is detected on a sensor; when the value is 127, the maximum possible pressure intensity is detected on the sensor. Since each sensor varies in its sensitivity, as described above, this translation of each signal into this standardized range of values from 0 to 127 makes it possible to calibrate the sensors against one another, enabling comparisons across them.</p>
        <p>The receiver is sent these absolute pressure magnitudes continuously by each sensor. The computer then turns this information from each individual sensor into a series of pressure magnitudes over time. Thus, for example, in a single glove, the four embedded sensors send a signal that each is turned into a value between 0 and 127, and these values are recorded across very small time intervals, making it possible to see how these values change over time. The data are stored and translated in MIDI format (to maximize data compression), which can then be used in other ways, e.g., for visualization.</p>
        <FigureContainer>
            <Table>
                <thead>
                    <tr>
                        <th scope="cols">Time Elapsed (seconds)</th> 
                        <th scope="cols">Wearable</th>
                        <th scope="cols">Sensor Values</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>24.57</td>
                        <td>Glove 1</td>
                        <td>0 / 0 / 21 / 114</td>
                    </tr>
                    <tr>
                        <td>24.57</td>
                        <td>Glove 2</td>
                        <td>0 / 0 / 30 / 0</td>
                    </tr>
                    <tr>
                        <td>24.57</td>
                        <td>Insole 1</td>
                        <td>10 / 0 / 16 / 0</td>
                    </tr>
                    <tr>
                        <td>24.57</td>
                        <td>Insole 2</td>
                        <td>0 / 41 / 50 / 102</td>
                    </tr>
                    <tr>
                        <td>24.74</td>
                        <td>Glove 1</td>
                        <td>0 / 0 / 20 / 114</td>
                    </tr>
                    <tr>
                        <td>24.74</td>
                        <td>Glove 2</td>
                        <td>0 / 0 / 29 / 0 </td>
                    </tr>
                    <tr>
                        <td>24.74</td>
                        <td>Insole 1</td>
                        <td>12 / 0 / 16 / 0</td>
                    </tr>
                    <tr>
                        <td>24.74</td>
                        <td>Insole 2</td>
                        <td>0 / 41 / 50 / 102</td>
                    </tr>
                </tbody>
            </Table>
        </FigureContainer>
        <p>While this process generates a very large amount of data, one of the major challenges in using and interpreting the data rests in evaluating the meaningfulness of those data. Specifically, the range of the sensor data, calibrated across all of the sensors, is not very expressive. Since the sensors vary in their sensitivity, it is difficult to distinguish noise arising through imperfections in the sensors’ sensitivity from real, subtle kinesthetic shifts that are happening in the body. At any given time, an individual sensor may fire accidentally because of pressure from the material in the wearable (and not originating from the body of a dancer), or may not fire at all due to a lost connection with the transmitter. These realities in the physical limitations of the sensors produce artifacts in the data generated from them, meaning that those data must be interpreted to be only as meaningful as the upper limit of the noise embedded within the data.
    </p>
    <p>As discussed in the previous section, understanding what exactly the sensors are capable of capturing on a kinesthetic level is vital to framing their kinesthetic legibility. The data, as a downstream expression of what is captured by the sensors, reify these questions. <AccentedText>The imperative that arises from this acknowledgment is one of representation: How can meaning in these data be read and communicated in a way that points toward kinesthetic information, without misrepresenting what is actually occurring in the body?</AccentedText> The following discussion addresses this.
</p>
<ReadNextSection onClick={() => setWhichSectionToView(LoopSectionName.Visualization)}>Keep reading: Visualization →</ReadNextSection>

    </FullScreenContentContainer>;
}

export default Data;